import { FC, useState } from "react";

import { Tooltip, TooltipContent, TooltipPortal, TooltipProvider, TooltipTrigger } from "@/components/_atoms/tooltip";
import { useIsTruncated } from "@/hooks/use-is-truncated";
import { cn } from "@/lib/cn";

const TOOLTIP_DELAY_MS = 300;

interface TruncatedTextProps {
  text: string;
  canTruncate?: boolean;
  className?: string;
}

export const TruncatedText: FC<TruncatedTextProps> = ({ text, canTruncate = true, className }) => {
  const { ref, isTruncated } = useIsTruncated<HTMLSpanElement>();
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  // Dropping the title once Radix opens keeps the browser from stacking its own tooltip on top.
  const nativeTitle = isTruncated && !isTooltipOpen ? text : undefined;

  if (!canTruncate) {
    return <span className={cn("whitespace-nowrap", className)}>{text}</span>;
  }

  return (
    <TooltipProvider delayDuration={TOOLTIP_DELAY_MS}>
      <Tooltip open={isTruncated && isTooltipOpen} onOpenChange={setIsTooltipOpen}>
        <TooltipTrigger asChild>
          <span ref={ref} title={nativeTitle} className={cn("block min-w-0 truncate", className)}>
            {text}
          </span>
        </TooltipTrigger>
        <TooltipPortal>
          <TooltipContent side="left" className="max-w-xs">
            {text}
          </TooltipContent>
        </TooltipPortal>
      </Tooltip>
    </TooltipProvider>
  );
};
